import { call, put, takeLatest } from "redux-saga/effects";
import get from "lodash/get";
import { httpRequest } from "../../../utils/networkCalls";
import { updateLoadingStatus } from "../../Loader/LoaderReducer";
import {scrollToTop, showToastMessage} from "../../../utils/common"
import { aiMhHandlePopupOpen } from "../AimhLandingPage/AimhLpReducer";
import history from "../../../utils/history";
import { AI_DESC_EG_CALL_REWRITE_PARAGRAPH, AI_DESC_RP_GENERATE_REWRITE_PARAGRAPH, AI_DESC_RP_HANDLE_ACTION_REWRITE_PARAGRAPH, AI_DESC_RP_REGENERATE_REWRITE_PARAGRAPH, fetchRewriteParagraph, handleRpSeverBusyPopup, updateActionRewriteParagraph } from "./RewriteParagraphReducer";
import { checkActRes, rpFormat } from "./RewriteParagraphUtils";

// Generate description
export function* GenRewriteParagraph(action) {
    try {
        // Show Loader here
        yield put(updateLoadingStatus(true));

        // Call API
        const res = yield call(
            httpRequest,
            "/ai-marketing-hub/generate-text",
            "post",
            action.payload
        );

        // Set up format
        let resArr = [];
        if (res?.status === "success" && res?.data.length > 0) {
            resArr = rpFormat(res?.data);

            // Set Response in Reducer
            yield put(fetchRewriteParagraph({paragraphs:resArr}));
            scrollToTop()
        }else if(res?.status==="error" && res?.data==="Exhausted the free trial limit"){
            yield put(
                aiMhHandlePopupOpen({ type: "eftPopup", isVisible: true })
            );
            history.push("/ai-marketinghub")
        }else if(res?.status==="error" && res?.data){
            if(res.data==="Request failed with status code 429"){
                yield put(handleRpSeverBusyPopup({isShow:true}))
            }else{
                showToastMessage({ icon: "error", mssge: res?.data, time: 3000 });
            }
        }else if(res?.status==="error"){
            showToastMessage({ icon: "error", mssge: "Something went wrong", time: 3000 });
        }

        // Hide Loader here
        yield put(updateLoadingStatus(false));

    } catch (err) {
        throw err;
    }
}

// Regenerate description
export function* ReGenRewriteParagraph(action) {
    try {
        // Show Loader here
        yield put(updateLoadingStatus(true));

        // Call API
        // const res = yield call(
        //     httpRequest,
        //     "/ai-marketing-hub/regenerate-text",
        //     "post",
        //     action.payload
        // );

        const res = yield call(
            httpRequest,
            "/ai-marketing-hub/rewrite-generations",
            "post",
            action.payload
        );

        // Set up format
        let resArr = [];
        if (res?.status === "success" && res?.data.length > 0) {
            resArr = rpFormat(res?.data);

            // Set Response in Reducer
            yield put(fetchRewriteParagraph({paragraphs:resArr}));
        }else if(res?.status==="error" && res?.data==="Exhausted the free trial limit"){
            yield put(
                aiMhHandlePopupOpen({ type: "eftPopup", isVisible: true })
            );
            history.push("/ai-marketinghub")
        }else if(res?.status==="error" && res?.data){
            showToastMessage({ icon: "error", mssge: res?.data, time: 3000 });
        }else if(res?.status==="error"){
            showToastMessage({ icon: "error", mssge: "Something went wrong", time: 3000 });
        }

        // Hide Loader here
        yield put(updateLoadingStatus(false));

    } catch (err) {
        throw err;
    }
}

// Handle actions (like, dislike, save etc) description
export function* handleActionRewriteParagraph(action) {
    try {

        // Call API
        const res = yield call(
            httpRequest,
            `/ai-marketing-hub/update-description/${action.payload.gen_id}`,
            "patch",
            action.payload.actionInfo
        );

        if(res?.status==="success"){
            // Check for response
            if (checkActRes(res, action)) {
                // Set Response in Reducer
                yield put(
                    updateActionRewriteParagraph({
                        descInd: action.payload.descInd,
                        actionInfo: action.payload.actionInfo,
                        isEdited: res.data[action.payload.descInd].is_edited
                    })
                );
                if(action.payload.actionInfo.hasOwnProperty("like_status")){
                    showToastMessage({ icon: "success", mssge: "Thank you for your feedback!", time: 3000 });
                }else{
                    showToastMessage({ icon: "success", mssge: "Changes Saved", time: 3000 });
                }
            }else{
                showToastMessage({ icon: "error", mssge: "Changes could not be Saved", time: 3000 });
            }
        }else if(res?.status==="error" && res?.data){
            showToastMessage({ icon: "error", mssge: res?.data, time: 3000 });
        }else if(res?.status==="error"){
            showToastMessage({ icon: "error", mssge: "Something went wrong", time: 3000 });
        }
    } catch (err) {
        throw err;
    }
}

export function* sagaRewriteParagraph(params) {
    // GenEmailDesc gets called when AI_DESC_PD_GENERATE_DESC is dispatched
    yield takeLatest(AI_DESC_RP_GENERATE_REWRITE_PARAGRAPH, GenRewriteParagraph);
    yield takeLatest(AI_DESC_RP_REGENERATE_REWRITE_PARAGRAPH, ReGenRewriteParagraph);
    yield takeLatest(AI_DESC_RP_HANDLE_ACTION_REWRITE_PARAGRAPH, handleActionRewriteParagraph);
}
